function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import LOADING_MODE from '../../common/constants/loadingMode';
import LAZY_LOAD from '../../common/constants/lazyLoad';
import { GalleryComponent } from '../galleryComponent';
import { isSEOMode } from '../../common/window/viewModeWrapper';
import { URL_TYPES, URL_SIZES } from '../../common/constants/urlTypes';

var ImageItem =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ImageItem, _GalleryComponent);

  function ImageItem() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ImageItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    try {
      if (typeof this.props.actions.setItemLoaded === 'function') {
        this.props.actions.setItemLoaded();
      }
    } catch (e) {
      console.error(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        alt = _this$props.alt,
        displayed = _this$props.displayed,
        imageDimensions = _this$props.imageDimensions,
        createUrl = _this$props.createUrl,
        id = _this$props.id,
        actions = _this$props.actions,
        settings = _this$props.settings,
        lazyLoad = _this$props.lazyLoad,
        styleParams = _this$props.styleParams;
    var imageProps = settings && settings.imageProps && typeof settings.imageProps === 'function' ? settings.imageProps(id) : {};
    var backgroundStyle = {}; //remove this inline style if rendered padding (using css) is used

    var _ref = imageDimensions || {},
        marginLeft = _ref.marginLeft,
        marginTop = _ref.marginTop,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref, ["marginLeft", "marginTop"]);

    var useImageTag = lazyLoad === LAZY_LOAD.NATIVE || isSEOMode();
    var imageItemClassName = ['gallery-item-content', 'image-item', 'gallery-item-visible', 'gallery-item', 'gallery-item-preloaded', styleParams.cubeImages && styleParams.cubeType === 'fit' ? 'grid-fit' : '', styleParams.imageLoadingMode === LOADING_MODE.COLOR ? 'load-with-color' : ''].join(' ');

    var imageContainer = function imageContainer(image) {
      return React.createElement("div", {
        className: imageItemClassName,
        onTouchStart: actions.handleItemMouseDown,
        onTouchEnd: actions.handleItemMouseUp,
        key: 'image_container-' + id,
        "data-hook": 'image-item',
        style: displayed ? imageDimensions.borderRadius ? {
          borderRadius: imageDimensions.borderRadius
        } : {} : _objectSpread({}, backgroundStyle, {}, restOfDimensions)
      }, image);
    };

    var image = React.createElement("img", _extends({
      key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
      className: 'gallery-item-visible gallery-item gallery-item-preloaded',
      alt: alt ? alt : 'untitled image',
      src: createUrl(URL_SIZES.RESIZED, isSEOMode() ? URL_TYPES.SEO : URL_TYPES.HIGH_RES),
      loading: "lazy",
      style: restOfDimensions
    }, imageProps));
    var canvas = React.createElement("canvas", _extends({
      key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
      className: 'gallery-item-visible gallery-item gallery-item-hidden gallery-item-preloaded',
      "data-hook": "gallery-item-image-canvas",
      role: "img",
      alt: alt ? alt : 'untitled image',
      "data-src": createUrl(URL_SIZES.RESIZED, URL_TYPES.HIGH_RES),
      style: restOfDimensions
    }, imageProps));
    var renderedItem = useImageTag ? imageContainer(image) : imageContainer(canvas);
    return renderedItem;
  };

  return ImageItem;
}(GalleryComponent);

export { ImageItem as default };